import { dbCapability, dbPostgresCapability, dbSqliteCapability } from './db';
import { secureStorageCapability } from './secureStorage';
import { recordsCapability } from './records';

/**
 * Registry of native-capability handlers, keyed by the manifest permission
 * string. hostBridge.js only dispatches a method if its owning capability
 * both exists here and was granted to the extension at install time.
 */
export const capabilities = {
  [dbCapability.capability]: dbCapability,
  [dbPostgresCapability.capability]: dbPostgresCapability,
  [dbSqliteCapability.capability]: dbSqliteCapability,
  [secureStorageCapability.capability]: secureStorageCapability,
  [recordsCapability.capability]: recordsCapability,
};
